// extracted by mini-css-extract-plugin
export default {"success":"success_success__F2hCj","button":"success_button__PznNh"};